import BigNumber from 'bignumber.js'

import { StakeFunc } from '../types'
import { safeGasEstimates } from '../utils'

export const stakeDoppple: StakeFunc = async ({ pool, contractAddress, walletAddress, amount, web3 }) => {
  try {
    const { DoppleFairLaunch: DoppleAbi } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(DoppleAbi as any, contractAddress)
    const contractWithMethod = ct.methods.deposit(walletAddress, pool, new BigNumber(amount).div(1e18).toFixed())
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
  } catch (e) {
    return false
  }
}

export const unStakeDopple: StakeFunc = async ({ web3, pool, contractAddress, walletAddress, amount }) => {
  try {
    const { DoppleFairLaunch: DoppleAbi } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(DoppleAbi as any, contractAddress)
    // const stringAmount = '443.359388341991744678'
    const stringAmount = new BigNumber(`${amount}`).multipliedBy(1e18).toFixed()
    if (amount === '0') {
      const contractWithMethod = ct.methods.harvest(`${pool}`)
      const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

      await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
    } else {
      const contractWithMethod = ct.methods.withdraw(walletAddress, `${pool}`, stringAmount)
      const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

      await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
    }
    return true
  } catch (e) {
    console.log(e)
    return false
  }
}
